import React, { useState, useEffect } from "react";
import "../css/index.css";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  Timestamp
} from "firebase/firestore";
import LoginForm from "./LoginForm";
import { firestore } from "../firebase-config";
import { useStateValue } from "../context/StateProvider";

function App() {
  const [rows, setRows] = useState([]);
  const [tempRows, setTempRows] = useState([]);
  const [totals, setTotals] = useState({ biz: 0, siz: 0 });
  const [sortConfig, setSortConfig] = useState(null); // Sıralama bilgisi
  const [{ user }] = useStateValue();

  // Firestore'dan verileri çekme
  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, "2025"));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRows(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchData();
  }, [user]);

  // Toplamları hesaplama
  useEffect(() => {
    const bizTotal = [...rows, ...tempRows].reduce(
      (sum, row) => sum + parseInt(row.biz || 0, 10),
      0
    );
    const sizTotal = [...rows, ...tempRows].reduce(
      (sum, row) => sum + parseInt(row.siz || 0, 10),
      0
    );
    setTotals({ biz: bizTotal, siz: sizTotal });
  }, [rows, tempRows]);

  // Yeni geçici satır ekleme
  const addRow = () => {
    console.log("addRow called");
    const newRow = {
      id: `temp-${Date.now()}`,
      date: "",
      biz: "",
      siz: "",
      isLocked: false,
      displayName: user ? user.displayName : "Unknown User",
    };
    setTempRows([...tempRows, newRow]);
  };

  const saveRow = async (tempRow) => {
    // Doğrulama: Sadece 0 veya 1 içermeli
    if (tempRow.biz !== "0" && tempRow.biz !== "1") {
      alert("Biz alanı yalnızca 0 veya 1 olabilir!");
      return;
    }
    if (tempRow.siz !== "0" && tempRow.siz !== "1") {
      alert("Siz alanı yalnızca 0 veya 1 olabilir!");
      return;
    }
  
    try {
      const currentDate = new Date(); // Tarih bilgisini bir değişkende sakla
      const timestamp = Timestamp.fromDate(currentDate); // Timestamp nesnesi oluştur
        
        
      // Yeni doküman Firestore'a ekle
      const newDoc = await addDoc(collection(firestore, "2025"), {
        date: timestamp,
        biz: tempRow.biz,
        siz: tempRow.siz,
        isLocked: true,
        displayName: user ? user.displayName : "Unknown User",
      });
  
      // Kaydedilen satır oluştur
      const savedRow = {
        id: newDoc.id,
        date: timestamp,
        biz: tempRow.biz,
        siz: tempRow.siz,
        isLocked: true,
        displayName: user ? user.displayName : "Unknown User",
      };
  
      // Yeni satırı ekle ve geçici satırları güncelle
      setRows([...rows, savedRow]);
      setTempRows(tempRows.filter((row) => row.id !== tempRow.id));
  
      console.log("Row added to Firestore successfully!");
    } catch (error) {
      console.error("Error saving row to Firestore: ", error);
    }
  };
  
// Geçici satır değerlerini güncelleme
const updateTempRow = (id, field, value) => {
  if (value === "" || value === "0" || value === "1") {
    const updatedRows = tempRows.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setTempRows(updatedRows);
  } else {
    alert("Sadece 0 veya 1 girilebilir!");
  }
};


  // Satırı silme
  const deleteRow = async (id) => {
    const confirmation = window.confirm(
      "Bu satırı silmek istediğinizden emin misiniz?"
    );
    if (confirmation) {
      try {
        if (id.startsWith("temp-")) {
          setTempRows(tempRows.filter((row) => row.id !== id));
        } else {
          const docRef = doc(firestore, "2025", id.toString());
          await deleteDoc(docRef);
          setRows(rows.filter((row) => row.id !== id));
        }
        console.log("Row deleted successfully!");
      } catch (error) {
        console.error("Error deleting row: ", error);
      }
    }
  };

  // Kullanıcı kolonunda sıralama
  const requestSort = (field) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === field &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: field, direction });
  };
  

  
  const sortedRows = React.useMemo(() => {
    let sortableRows = [...rows];
  
    // Sayfa yüklendiğinde büyükten küçüğe sıralama
    if (sortableRows.length > 0) {
      sortableRows.sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  
    if (sortConfig !== null) {
      sortableRows = sortableRows.sort((a, b) => {
        if (sortConfig.key === 'date') {
          return sortConfig.direction === 'ascending'
          ? a.date.toDate() - b.date.toDate() // Timestamp nesnelerini Date'e çevirerek karşılaştır
          : b.date.toDate() - a.date.toDate();


        } else if (sortConfig.key === 'displayName') {
          if (a.displayName < b.displayName) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (a.displayName > b.displayName) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
        return 0;
      });
    }
    return sortableRows;
  }, [rows, tempRows, sortConfig]);
  
  

  return (
<div className="min-h-screen bg-gray-100 p-5 flex flex-col">
  <div className="flex justify-end">
    <LoginForm />
  </div>
  <div className="">
    <h1 className="text-2xl font-bold text-center mb-5 text-blue-600">
      Biz-Siz Tablosu
    </h1>
    {/* Kaydırılabilir konteyner */}
    <div className="overflow-x-auto">
      <table className="table-auto w-full border border-gray-300 bg-white">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-300 px-2 py-1">
              Tarih
              <button
                className={`ml-2 ${
                  sortConfig && sortConfig.key === "date"
                    ? sortConfig.direction === "ascending"
                      ? "text-blue-600"
                      : "text-red-600"
                    : "text-gray-500"
                }`}
                onClick={() => requestSort("date")}
              >
                {sortConfig && sortConfig.key === "date"
                  ? sortConfig.direction === "ascending"
                    ? "↓"
                    : "↑"
                  : "↕"}
              </button>
            </th>
            <th className="border border-gray-300 px-2 py-1">
              Biz <span className="text-blue-600">({totals.biz})</span>
            </th>
            <th className="border border-gray-300 px-2 py-1">
              Siz <span className="text-blue-600">({totals.siz})</span>
            </th>
            <th className="border border-gray-300 px-2 py-1">
              Kullanıcı
              <button
                className={`ml-2 ${
                  sortConfig && sortConfig.key === "displayName"
                    ? sortConfig.direction === "ascending"
                      ? "text-blue-600"
                      : "text-red-600"
                    : "text-gray-500"
                }`}
                onClick={() => requestSort("displayName")}
              >
                {sortConfig && sortConfig.key === "displayName"
                  ? sortConfig.direction === "ascending"
                    ? "↓"
                    : "↑"
                  : "↕"}
              </button>
            </th>
            <th className="border border-gray-300 px-2 py-1">İşlem</th>
          </tr>
        </thead>
        <tbody>
          {sortedRows.map((row) => (
            <tr key={row.id}>
              <td className="border border-gray-300 px-2 py-1 text-center">
                {/* {new Date(row.date).toLocaleDateString()} */}
                {new Date(row.date.seconds * 1000).toLocaleDateString('tr-TR', { hour: 'numeric', minute: 'numeric', second: 'numeric' })}
              </td>
              <td className="border border-gray-300 px-2 py-1 text-center">
                {row.biz}
              </td>
              <td className="border border-gray-300 px-2 py-1 text-center">
                {row.siz}
              </td>
              <td className="border border-gray-300 px-2 py-1 text-center">
                {row.displayName}
              </td>
              <td className="border border-gray-300 px-2 py-1 text-center">
                <button
                  onClick={() => deleteRow(row.id)}
                  className="px-2 py-1 bg-red-500 text-white rounded-md"
                >
                  Sil
                </button>
              </td>
            </tr>
          ))}
          {tempRows.map((tempRow) => (
            <tr key={tempRow.id}>
              <td className="border border-gray-300 px-2 py-1 text-center">
                {tempRow.date || "Henüz eklenmedi"}
              </td>
              <td className="border border-gray-300 px-2 py-1 text-center">
                <input
                  type="text"
                  value={tempRow.biz}
                  onChange={(e) =>
                    updateTempRow(tempRow.id, "biz", e.target.value)
                  }
                  className="border border-gray-300 p-1 w-full text-center"
                />
              </td>
              <td className="border border-gray-300 px-2 py-1 text-center">
                <input
                  type="text"
                  value={tempRow.siz}
                  onChange={(e) =>
                    updateTempRow(tempRow.id, "siz", e.target.value)
                  }
                  className="border border-gray-300 p-1 w-full text-center"
                />
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {tempRow.displayName}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                <button
                  onClick={() => saveRow(tempRow)}
                  className="px-2 py-1 bg-blue-500 text-white mb-1"
                >
                  Kaydet
                </button>
                <button
                  onClick={() => deleteRow(tempRow.id)}
                  className="px-2 py-1 bg-gray-500 text-white ml-2"
                >
                  Sil
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <button
      onClick={addRow}
      className="mt-5 bg-blue-500 text-white px-2 py-1 rounded-md"
    >
      Satır Ekle
    </button>
  </div>
</div>

  );
}

export default App;